export default {
  todayAlertCount: '本日のアラート数',
  scanCountAlert: 'スキャン回数アラート',
  crossRegionAlert: 'クロスリージョンアラート',
  vsYesterday: '昨日比',
  qrcode: 'QRコード',
  qrcodePlaceholder: 'QRコード番号を入力してください',
  alertTime: 'アラート時間',
  startTime: '開始時間',
  endTime: '終了時間',
  alertType: 'アラートタイプ',
  alertTypePlaceholder: '選択してください',
  alertStatus: 'アラート状態',
  alertStatusPlaceholder: '選択してください',
  typeScanCount: '回数アラート',
  typeCrossRegion: 'クロスリージョンアラート',
  statusAlerting: 'アラート中',
  statusResolved: '解除済み',
  statusDisabled: '無効',
  export: 'エクスポート',
  colQrcode: 'QRコード',
  colUserInfo: 'ユーザー情報',
  colProductInfo: '製品情報',
  colAlertRule: 'アラートルール',
  colAlertStatus: 'アラート状態',
  colAlertTime: 'アラート時間',
  colAction: '操作',
  resolveAlert: 'アラート解除',
  disableQrcode: 'QRコード無効化',
  resolveTitle: 'アラート解除',
  resolveContent: 'このアラートを解除してもよろしいですか？',
  resolveRemark: '処理備考',
  resolveRemarkPlaceholder: '処理備考を入力してください（任意）',
  disableTitle: 'QRコード無効化',
  disableContent:
    'このQRコードを無効にしてもよろしいですか？無効にするとスキャン時に無効のメッセージが表示されます。',
  disableReason: '無効理由',
  disableReasonPlaceholder: '無効理由を入力してください',
  disableReasonRequired: '無効理由を入力してください',
  emptyText: 'アラート記録がありません',
};
